import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from "react-data-table-component";
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import Select from "react-select";
import Popup from "react-popup";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import ReimpresionInterbancariaService from "../../../services/consultas/ReimpresionInterbancariaService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faDownload  } from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";
const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};
const DetalleFila = ({ data }) => (
  <div className="row" style={{ margin: 0, fontSize: 13, marginBottom: 20 }}>
    <div className="col-md-12">
      <p style={{ fontWeight: 500, marginBottom: 0 }}>Detalles:</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Operación: {data.operacion}</p>
    </div>
    <div className="col-md-2">
      <p style={{ marginBottom: 0 }}>Cuenta Débito: {data.cuentaDebito}</p>
    </div>
    <div className="col-md-8">
      <p style={{ marginBottom: 0 }}>
        Nombre Cuenta Origen: {data.nombreCuentaOrigen}
      </p>
    </div>
  </div>
);
export default class TransferenciaInterbancariaComprobante extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaTransferencia: [],
      listaPeriodo: [],
      periodoElegido: [],
    };
  }
  descargar = async (row) => {
    await trackPromise(
      ReimpresionInterbancariaService.descagarComponente(
        "Interbancarias via SIPAP",
        row.operacion,
        row.cuentaDebito +
          " - " +
          row.nombreCuentaOrigen,
        row.tipoCuentaDebito,
        row.moneda,
        row.cuentaDebito,
        row.cuentaCredito,
        row.monto,
        row.monto,
        row.nombreCuentaDestino,
        row.entidadDestino,
        row.fecha,
        row.tipoDocumentoDestino,
        row.nroDocumentoDestino
      )
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
 
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  componentDidMount() {
    this.obtenerPeriodo();
  }
  obtenerPeriodo = () => {
    var lista = [];
    lista.push({
      value: null,
      label: "--Seleccione--",
    });
    var now = new Date();
    var mes = now.getMonth() + 1;
    var anio = now.getFullYear();
    var mesChar = "";
    for (var i = 0; i < 12; i++) {
      if (mes === 0) {
        mes = 12;
        anio = anio - 1;
      }
      mesChar = mes.toString().length === 1 ? "0" + mes : mes;
      lista.push({
        value: mesChar + "" + anio,
        label: mesChar + "/" + anio,
      });
      mes = mes - 1;
    }
    this.setState({ listaPeriodo: lista });
    return lista;
  };
  dibujarListaTransferencia() {
    if (
      this.state.listaTransferencia === undefined ||
      this.state.listaTransferencia.length === 0
    ) {
      return <div></div>;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <DatosSocio />
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={this.getColumn()}
                      data={this.state.listaTransferencia}
                      dense={true}
                      striped={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="no hay registros para mostrar"
                      expandableRows
                      expandableRowsComponent={DetalleFila}
                      // expandableRowsComponent={
                      //   <DetalleFila data={this.state.listaTransferencia} />
                      // }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  handleChangeSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        listaTransferencia: [],
        periodoElegido: null,
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value,
      });
    }
  };
  selDescarga = (e) => {
    var operacion = e.currentTarget.value;
    var foundItem = $.grep(this.state.listaTransferencia, function (v) {
      var item = v.operacion.toString();
      return item.trim() === operacion.toString();
    });
    this.descargar(foundItem[0]);
  };
  getColumn() {
    return [
      {
        name: "Fecha",
        selector: row => row.fecha,
      },
      {
        name: "Operación",
        selector: row => row.operacion,
        width: "80px",
        omit: true,
      },
      {
        name: "Cuenta Débito",
        selector: row => row.cuentaDebito,
        width: "90px",
        omit: true,
      },
      {
        name: "Nombre Cuenta Origen",
        selector: row => row.nombreCuentaOrigen,
        width: "280px",
        omit: true,
      },
      {
        name: "Cuenta Crédito",
        selector: row => row.cuentaCredito,
      },
      {
        name: "Entidad Destino",
        selector: row => row.entidadDestino,
      },
      {
        name: "Nombre Cuenta Destino",
        selector: row => row.nombreCuentaDestino,
        width: "190px",
      },
      {
        name: "Importe",
        selector: row => row.importe,
        right: true,
      },
      {
        cell: (row) => (
          <div>
            <button
              ref={() => this.entidadSelected}
              id={"imprimir_" + row.operacion}
              key={row.operacion}
              className="btn btn-xs btn-outline-success"
              value={row.operacion}
              onClick={this.selDescarga}
            >
              <FontAwesomeIcon icon={faDownload} /> <b>Descargar</b>
            </button>
          </div>
        ),
        width: "120px",
      },
    ];
  }
  obtenerListaTransferencia = async () => {
    if (this.state.periodoElegido !== null) {
      var anioMes = this.state.periodoElegido;
      var listaTransferencia = [];
      await trackPromise(
        ReimpresionInterbancariaService.reimprimirLista(
          authService.getCurrentUser().cedulaIdentidad,
          anioMes
        )
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            var resultados = jsonData.datos;
            if (jsonData.codigo === 0) {
              for (var i = 0; i < resultados.length; i++) {
                listaTransferencia.push({
                  fecha: resultados[i].fecha_trans,
                  operacion: resultados[i].operacion,
                  cuentaDebito: resultados[i].cuenta_debito,
                  nombreCuentaOrigen: resultados[i].nombre_origen,
                  cuentaCredito: resultados[i].cuenta_credito,
                  entidadDestino: resultados[i].banco_destino,
                  nombreCuentaDestino: resultados[i].nombre_destino,
                  importe:
                    formatoSeparadorMilesValue(resultados[i].importe) +
                    " " +
                    resultados[i].id_moneda,
                  moneda: resultados[i].id_moneda,
                  monto: formatoSeparadorMilesValue(resultados[i].importe),
                  tipoCuentaDebito: resultados[i].tipo_cuenta_debito,
                  tipoDocumentoDestino: resultados[i].tipoDocumentoDestino,
                  nroDocumentoDestino: resultados[i].nroDocumentoDestino
                });
              }
            } else {
              Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );
      this.setState({ listaTransferencia: listaTransferencia });
    }
    this.setState({ listaTransferencia: listaTransferencia });
    return listaTransferencia;
  };
  render() {
    var periodo = this.state.listaPeriodo;
    if (this.state.listaPeriodo.length === 0) periodo = this.state.listaPeriodo;
    return (
      <div className="content-wrapper">
        <Titulo texto="Interbancarias via SIPAP - Comprobante" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{zIndex:1}}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                      <label className="input-label-bold">Mes *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangeSelector}
                            options={periodo}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                      <button
                          className="btn btn-cu-primary"
                          onClick={() => this.obtenerListaTransferencia()}
                        >
                        <FontAwesomeIcon icon={faCheck} />  Consultar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.dibujarListaTransferencia()}
          </div>
        </section>
      </div>
    );
  }
}